function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import morphdom from 'morphdom';
import CableReady from '..';
import SubscribingElement from './subscribing_element';
import { shouldMorph } from '../morph_callbacks';
import activeElement from '../active_element';
import { debounce, assignFocus, dispatch, graciouslyFetch } from '../utils';
var template = "\n<style>\n  :host {\n    display: block;\n  }\n</style>\n<slot></slot>\n";

function url(ele) {
  return ele.hasAttribute('url') ? ele.getAttribute('url') : location.href;
}

var UpdatesForElement = /*#__PURE__*/function (_SubscribingElement) {
  _inherits(UpdatesForElement, _SubscribingElement);

  var _super = _createSuper(UpdatesForElement);

  function UpdatesForElement() {
    var _this;

    _classCallCheck(this, UpdatesForElement);

    _this = _super.call(this);

    var shadowRoot = _this.attachShadow({
      mode: 'open'
    });

    shadowRoot.innerHTML = template;
    return _this;
  }

  _createClass(UpdatesForElement, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var consumer;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.preview) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                this.update = debounce(this.update.bind(this), this.debounce);
                _context.next = 5;
                return CableReady.consumer;

              case 5:
                consumer = _context.sent;

                if (consumer) {
                  this.createSubscription(consumer, 'CableReady::Stream', this.update);
                } else {
                  console.error('The `updates-for` helper cannot connect without an ActionCable consumer.\nPlease run `rails generate cable_ready:helpers` to fix this.');
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data) {
        var _this2 = this;

        var identifier, query, blocks, only, html, template, _loop, i, _ret;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                identifier = this.getAttribute('identifier');
                query = "updates-for[identifier=\"".concat(identifier, "\"]");
                blocks = document.querySelectorAll(query);

                if (!(blocks[0] !== this)) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return");

              case 5:
                only = this.getAttribute('only');

                if (!(only && data.changed && !only.split(' ').some(function (attribute) {
                  return data.changed.includes(attribute);
                }))) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return");

              case 8:
                html = {};
                template = document.createElement('template');
                _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(i) {
                  var response, fragments, operation;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          blocks[i].setAttribute('updating', 'updating');

                          if (html.hasOwnProperty(url(blocks[i]))) {
                            _context2.next = 8;
                            break;
                          }

                          _context2.next = 4;
                          return graciouslyFetch(url(blocks[i]), {
                            'X-Cable-Ready': 'update'
                          });

                        case 4:
                          response = _context2.sent;
                          _context2.next = 7;
                          return response.text();

                        case 7:
                          html[url(blocks[i])] = _context2.sent;

                        case 8:
                          template.innerHTML = String(html[url(blocks[i])]).trim();
                          _context2.next = 11;
                          return _this2.resolveTurboFrames(template.content);

                        case 11:
                          fragments = template.content.querySelectorAll(query);

                          if (!(fragments.length <= i)) {
                            _context2.next = 15;
                            break;
                          }

                          console.warn('Update aborted due to mismatched number of elements');
                          return _context2.abrupt("return", {
                            v: void 0
                          });

                        case 15:
                          activeElement.set(document.activeElement);
                          operation = {
                            element: blocks[i],
                            html: fragments[i],
                            permanentAttributeName: 'data-ignore-updates'
                          };
                          dispatch(blocks[i], 'cable-ready:before-update', operation);
                          morphdom(blocks[i], fragments[i], {
                            childrenOnly: true,
                            onBeforeElUpdated: shouldMorph(operation),
                            onElUpdated: function onElUpdated(_) {
                              blocks[i].removeAttribute('updating');
                              dispatch(blocks[i], 'cable-ready:after-update', operation);
                              assignFocus(operation.focusSelector);
                            }
                          });

                        case 19:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                });
                i = 0;

              case 12:
                if (!(i < blocks.length)) {
                  _context3.next = 20;
                  break;
                }

                return _context3.delegateYield(_loop(i), "t0", 14);

              case 14:
                _ret = _context3.t0;

                if (!(_typeof(_ret) === "object")) {
                  _context3.next = 17;
                  break;
                }

                return _context3.abrupt("return", _ret.v);

              case 17:
                i++;
                _context3.next = 12;
                break;

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function update(_x) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "resolveTurboFrames",
    value: function () {
      var _resolveTurboFrames = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(documentFragment) {
        var _this3 = this;

        var reloadingTurboFrames;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                reloadingTurboFrames = _toConsumableArray(documentFragment.querySelectorAll('turbo-frame[src]:not([loading="lazy"])'));
                return _context5.abrupt("return", Promise.all(reloadingTurboFrames.map(function (frame) {
                  return new Promise( /*#__PURE__*/function () {
                    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(resolve) {
                      var frameResponse, frameTemplate;
                      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              _context4.next = 2;
                              return graciouslyFetch(frame.getAttribute('src'), {
                                'Turbo-Frame': frame.id,
                                'X-Cable-Ready': 'update'
                              });

                            case 2:
                              frameResponse = _context4.sent;
                              frameTemplate = document.createElement('template');
                              _context4.next = 6;
                              return frameResponse.text();

                            case 6:
                              frameTemplate.innerHTML = _context4.sent;
                              _context4.next = 9;
                              return _this3.resolveTurboFrames(frameTemplate.content);

                            case 9:
                              documentFragment.querySelector("turbo-frame#".concat(frame.id)).innerHTML = String(frameTemplate.content.querySelector("turbo-frame#".concat(frame.id)).innerHTML).trim();
                              resolve();

                            case 11:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee4);
                    }));

                    return function (_x3) {
                      return _ref.apply(this, arguments);
                    };
                  }());
                })));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function resolveTurboFrames(_x2) {
        return _resolveTurboFrames.apply(this, arguments);
      }

      return resolveTurboFrames;
    }()
  }, {
    key: "debounce",
    get: function get() {
      return this.hasAttribute('debounce') ? parseInt(this.getAttribute('debounce')) : 20;
    }
  }]);

  return UpdatesForElement;
}(SubscribingElement);

export { UpdatesForElement as default };